import styled from "@emotion/styled";
import theme from "../../theme";
import DetectByHour from "../../screens/stastics/detectByHour";
import DetectByPeriod from "../../screens/stastics/detectByPeroid";
import useGetDetectByEvent from "../../hooks/useGetDetectByEvent";
import useGetDetectByHour from "../../hooks/useGetDetectByHour";
import { format } from "date-fns";
import { useWindowSize } from "@reactuses/core";
import { useI18n } from "../../locales";

const { md, lg } = theme.screen;

type Prop = {
  startDate: Date | null;
  endDate: Date | null;
  ownerID: string | undefined;
  area: string;
  mobility_seq: number | undefined;
};
export const ChartSection = ({
  startDate,
  endDate,
  ownerID,
  area,
  mobility_seq,
}: Prop) => {
  const { width } = useWindowSize();
  const { t } = useI18n();

  // 기간 내 감지 내역 데이터
  const { data: eventData, isLoading: eventDataIsLoading } =
    useGetDetectByEvent({
      startDate: format(new Date(startDate as Date), "yyyy-MM-dd"),
      endDate: format(new Date(endDate as Date), "yyyy-MM-dd"),
      fetch: true,
      ownerID: ownerID,
      area: area,
      mobility_seq: mobility_seq,
    });

  // 시간대별 감지 내역 데이터
  const { data: hourData, isLoading: hourDataIsLoading } =
    useGetDetectByHour({
      startDate: format(new Date(startDate as Date), "yyyy-MM-dd"),
      endDate: format(new Date(endDate as Date), "yyyy-MM-dd"),
      fetch: true,
      ownerID: ownerID,
      area: area,
      mobility_seq: mobility_seq,
    });

  // 시간대별 감지내역 데이터 카운트가 0개인지 체크
  const isEveryCntZero = hourData?.every((event) => {
    return event.data.every((data) => data.cnt === 0);
  });

  return (
    <ChartsContainer>
      {/* 기간 내 감지내역 */}
      {eventData
        ?.filter((el) => el.event !== "전체농기계" && el.event !== "운행한농기계")
        .map((el) => el)
        .every((el) => el.cnt === 0) ? (
        <DetectByEventError width={"534px"} height={"382px"}>
          {`${t.control.noDetectionInPeriod}\n${t.control.pleaseReselectDate}`}
        </DetectByEventError>
      ) : (
        <DetectByPeriod
          isGoogle={true}
          eventData={eventData}
          eventDataIsLoading={eventDataIsLoading}
          width={width <= md ? "100%" : "500"}
          legend={width <= md ? "bottom" : undefined}
        />
      )}

      {/* 시간대별 감지내역 */}
      {!isEveryCntZero ? (
        <DetectByHour
          isGoogle={true}
          hourData={hourData}
          hourDataIsLoading={hourDataIsLoading}
          width={width <= md ? "100%" : "500"}
          isReportModal
          isMobile={width <= md ? true : false}
        />
      ) : (
        <DetectByEventError width={"534px"} height={"382px"}>
          {`${t.control.noDetectionInPeriod}\n${t.control.pleaseReselectDate}`}
        </DetectByEventError>
      )}
    </ChartsContainer>
  );
};

const DetectByEventError = styled.div<{
  width: string;
  height: string;
}>`
  min-width: ${({ width }) => width};
  max-width: ${({ width }) => width};
  background: ${theme.color.neutral_50};
  border: 3px solid ${theme.color.neutral_100};
  border-radius: 15px;
  height: ${({ height }) => height};
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  white-space: pre-line;
  line-height: 150%;
  align-items: center;
  font-weight: 600;
  text-align: center;

  @media (max-width: ${md}px) {
    font-size: 14px;
  }
`;

const ChartsContainer = styled.div`
  display: flex;
  margin-top: 10px;
  gap: 30px;

  @media (min-width: ${0}px) and (max-width: ${lg}px) {
    flex-direction: column;
    gap: 10px;
  }

  > div {
    @media (max-width: ${lg}px) {
      display: flex;
      align-items: center;
      max-width: 100%;
      min-width: 100%;
      width: 100%;
    }
    @media (min-width: ${lg + 1}px) {
      min-width: 534px;
      max-width: 534px;
    }
  }

  @media print {
    flex-direction: row;
    min-width: 49.3%;
    max-width: 49.3%;
  }
`;
